<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible.sync="visible"
      width="700px"
      :title="$l('dialog_title_batchCreateOrderResult') || '补推送结果'"
      :close-on-click-modal="false"
      :before-close="close"
      append-to-body
      v-el-dialog-drag
    >
      <div class="batch-result-summary">
        <span>
          {{ $l('tips_batchCreateOrder_total') || '总推送数量' }}：
          {{ result.totalCount || 0 }}
        </span>
        <span>
          {{ $l('tips_batchCreateOrder_skip') || '跳过数量' }}：
          {{ result.skipCount || 0 }}
        </span>
        <span class="success">
          {{ $l('tips_batchCreateOrder_success') || '推送成功' }}：
          {{ result.successCount || 0 }}
        </span>
        <span class="fail">
          {{ $l('tips_batchCreateOrder_fail') || '推送失败' }}：
          {{ result.failCount || 0 }}
        </span>
      </div>
      <el-table
        v-if="hasFail"
        :data="result.listFailItem"
        size="small"
        border
        max-height="400"
      >
        <el-table-column
          prop="amzPurchaseNo"
          :label="$l('table_label_amzPurchaseNo') || '采购单号'"
          min-width="180"
        />
        <el-table-column
          prop="message"
          :label="$l('table_label_failReason') || '失败原因'"
          min-width="300"
          show-overflow-tooltip
        />
      </el-table>
      <span slot="footer">
        <el-button type="primary" size="small" @click="close">
          {{ $l('INDEX.btn_confirm') || '确定' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    visible: { type: Boolean, default: false },
    result: { type: Object, default: () => ({}) },
  },
  computed: {
    hasFail() {
      return (this.result.listFailItem || []).length > 0
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.batch-result-summary {
  margin-bottom: 12px;
  font-size: 14px;
  span + span {
    margin-left: 24px;
  }
  .success {
    color: #67c23a;
  }
  .fail {
    color: #f56c6c;
  }
}
</style>
